/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */
import React, { useState, useEffect, useContext } from 'react';

import MarkdownComponent from '../../components/markdown.component';
import { MarkdownWrapper } from '../../components/markdown.component/markdown.component.styled';
import PageContainer from '../../components/pageContainer';
import { SiteConfigContext } from '../../hooks/useSiteConfigContext';

const PrivacyPolicyPage = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState('');
  const [markdownStyle, setMarkdownStyle] = useState('');
  const { getSiteConfig } = useContext(SiteConfigContext);

  useEffect(() => {
    const siteConfig = getSiteConfig();

    if (siteConfig) {
      setPrivacyPolicy(siteConfig?.privacyPolicy);
      setMarkdownStyle(siteConfig?.markdownStyle);
    }
  }, [getSiteConfig()]);

  return (
    <PageContainer>
      <MarkdownWrapper>
        <MarkdownComponent
          markdown={privacyPolicy}
          markdownStyle={markdownStyle}
          isConfigurationsSuccess={true}
        />
      </MarkdownWrapper>
    </PageContainer>
  );
};

export default PrivacyPolicyPage;
